import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import AdminRoute from './components/AdminRoute';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import AllPosts from './pages/AllPosts';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import TermsConditions from './pages/legal/TermsConditions';
import Cookies from './pages/legal/Cookies';

// Admin
import AdminLogin from './pages/Admin/AdminLogin';
import AdminLayout from './pages/Admin/AdminLayout';
import Dashboard from './pages/Admin/pages/Dashboard';
import AdminServices from './pages/Admin/pages/AdminServices';
import AdminGallery from './pages/Admin/pages/AdminGallery';
import AdminTeam from './pages/Admin/pages/AdminTeam';
import AdminTestimonials from './pages/Admin/pages/AdminTestimonials';
import AdminProducts from './pages/Admin/pages/AdminProducts';
import AdminProjects from './pages/Admin/pages/AdminProjects';
import ProjectCategories from './pages/Admin/pages/ProjectCategories';
import AdminPartners from './pages/Admin/pages/AdminPartners';
import CreatePartner from './pages/Admin/pages/CreatePartner';
import AdminBlog from './pages/Admin/pages/AdminBlog';
import BlogCategories from './pages/Admin/pages/BlogCategories';
import AdminContact from './pages/Admin/pages/AdminContact';
import AdminSubscriptions from './pages/Admin/pages/AdminSubscriptions';
import AdminMails from './pages/Admin/pages/AdminMails';

import './App.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/musa');
  const isLegal = location.pathname.startsWith('/privacy-policy') || 
                  location.pathname.startsWith('/terms-conditions') || 
                  location.pathname.startsWith('/cookies');

  return (
    <div className="App">
      {children}
      {!isAdmin && !isLegal && <Footer />}
      {!isAdmin && !isLegal && <WhatsAppButton />}
    </div>
  );
};

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/all-posts" element={<AllPosts />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/cookies" element={<Cookies />} />

          <Route path="/musa/login" element={<AdminLogin />} />
          <Route path="/musa" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="gallery" element={<AdminGallery />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="projects/categories" element={<ProjectCategories />} />
            <Route path="partners" element={<AdminPartners />} />
            <Route path="partners/create" element={<CreatePartner />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="blog/categories" element={<BlogCategories />} />
            <Route path="contact" element={<AdminContact />} />
            <Route path="subscriptions" element={<AdminSubscriptions />} />
            <Route path="mails" element={<AdminMails />} />
          </Route>
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
